export const MAX_NAME_LENGTH = 50;
export const MAX_STORE_NAME_LENGTH = 50;
export const MIN_NAME_LENGTH = 2;
export const MIN_PASSWORD_LENGTH = 8;
export const MIN_STORE_NAME_LENGTH = 2;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/signup/const.js